import { render, staticRenderFns } from "./allianceMsg.vue?vue&type=template&id=0fe0e354&scoped=true"
import script from "./allianceMsg.vue?vue&type=script&lang=js"
export * from "./allianceMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe0e354",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fe0e354')) {
      api.createRecord('0fe0e354', component.options)
    } else {
      api.reload('0fe0e354', component.options)
    }
    module.hot.accept("./allianceMsg.vue?vue&type=template&id=0fe0e354&scoped=true", function () {
      api.rerender('0fe0e354', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/userDetails/components/allianceMsg.vue"
export default component.exports